import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { Select, Store } from '@ngxs/store';
import { ClearPreviewMessage, GetPreviewMessage } from 'ng2-app/messages/message-store/message.actions';
import { Observable } from 'rxjs';
import { MessageState } from 'ng2-app/messages/message-store/message.state';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule, NgIf } from '@angular/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatDividerModule } from '@angular/material/divider';
import {SanitizeModule} from 'ng2-app/pipes/sanitize/sanitize-pipe.module';

@Component({
  selector: 'app-message-preview-dialog',
  template: `
    <div class="column-grid tw-justify-between tw-place-items-center tw-pr-2">
      <h2 mat-dialog-title>Message Preview</h2>
      <button mat-icon-button
              mat-dialog-close>
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <mat-dialog-content>
      <ng-container *ngIf="!(loading$ | async) else loading">

        <div class="column-grid tw-gap-2 tw-justify-start">
          <span>Subject:</span>
          <div [innerHTML]="(messagePreview$ | async).subject"></div>
        </div>
        <div class="tw-relative tw-my-2">
          <mat-divider></mat-divider>
        </div>
        <div [innerHTML]="(messagePreview$ | async).html | sanitizeHtml"></div>
      </ng-container>
      <ng-template #loading>
        <mat-spinner diameter="50" class="tw-m-auto"></mat-spinner>
      </ng-template>
    </mat-dialog-content>
  `,
  imports: [
    CommonModule,
    MatButtonModule,
    MatDialogModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatDividerModule,
    SanitizeModule
  ]
})
export class MessagePreviewDialogComponent implements OnInit, OnDestroy {

  @Select(MessageState.loading) loading$: Observable<boolean>;
  @Select(MessageState.messagePreview) messagePreview$: Observable<any>;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    private store: Store,
  ) {}

  ngOnInit(): void {
    !!this.data.message && this.store.dispatch( new GetPreviewMessage(this.data.message) );
  }

  ngOnDestroy(): void {
    this.store.dispatch( new ClearPreviewMessage() );
  }
}
